<template>
  <button
    class="c-outage-tooltip"
    v-tooltip="{
      content: tooltipContent,
      html: true,
      triggers: ['click'],
      autoHide: true,
      delay: {
        show: 0,
        hide: 0,
      },
    }"
  >
    <span class="c-outage-tooltip__inner">?</span>
  </button>
</template>

<script>
export default {
  props: {
    tooltipContent: String,
  },
  created() {},
  components: {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss"></style>
